import { InfoOutlineIcon } from '@chakra-ui/icons';
import {
  type Placement,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverContent,
  Portal,
  Stack,
} from '@chakra-ui/react';
import type { PropsWithChildren } from 'react';

import {
  emitMixpanelUserEvent,
  PopoverTrigger,
  UserTrackingEvents,
} from '@revelio/core';
import { IconButton } from '@revelio/ui';

import styles from './PlotInfoComp.module.css';

export type PlotConfigObject = {
  iconBoxSize: number;
  popoverPlacement: Placement;
};

export interface PlotInfoCompProps extends PropsWithChildren {
  plotInfoConfig: PlotConfigObject | null;
  topLeft?: React.ReactNode;
  disableInfoPopup?: boolean;
}

export const PlotInfoComp = ({
  plotInfoConfig,
  topLeft,
  disableInfoPopup = false,
  children,
}: PlotInfoCompProps) => {
  return (
    <Stack spacing={0} direction="row" align="center" display="inline-flex">
      {children && !disableInfoPopup && (
        <Popover
          trigger="hover"
          placement={plotInfoConfig?.popoverPlacement}
          openDelay={500}
          onOpen={() => {
            emitMixpanelUserEvent(UserTrackingEvents.TOOLTIP_OPEN);
          }}
          variant="tooltip"
          isLazy
        >
          <PopoverTrigger>
            <IconButton
              className={styles.infoButton}
              aria-label="plot info"
              data-testid="plot-info-icon"
              icon={<InfoOutlineIcon boxSize={plotInfoConfig?.iconBoxSize} />}
            />
          </PopoverTrigger>
          <Portal>
            <PopoverContent className={styles.tooltip}>
              <PopoverArrow />
              <PopoverBody className={styles.body} data-testid="plot-info-body">
                {children}
              </PopoverBody>
            </PopoverContent>
          </Portal>
        </Popover>
      )}
      {topLeft}
    </Stack>
  );
};

export default PlotInfoComp;
